export default __webpack_public_path__ + "static/N0306-6202769156f7758bad41eeb1d28a0f25.png";